import { FormTemplateAttribute } from 'mapistry-shared';
import { useMemo } from 'react';
import { EditableFormTemplate, EditableFormTemplateField } from '../types';
import { useGetAllFieldsWithGroupSlugs } from './useGetAllFieldsWithGroupSlugs';

export const useGetInspectionDate = (
  formTemplate?: EditableFormTemplate,
): {
  inspectionDateField?: EditableFormTemplateField;
  inspectionDateGroupSlug?: string;
} => {
  const fieldsWithGroupSlugs = useGetAllFieldsWithGroupSlugs(formTemplate);
  return useMemo(() => {
    const inspectionDate = fieldsWithGroupSlugs?.find(({ field }) =>
      field.attributes?.includes(FormTemplateAttribute.IS_INSPECTION_DATE),
    );
    return {
      inspectionDateField: inspectionDate?.field,
      inspectionDateGroupSlug: inspectionDate?.groupSlug,
    };
  }, [fieldsWithGroupSlugs]);
};
